module.exports = __webpack_public_path__ + "static/media/whitespace.573e029c.pdf";